import ArrowLink from './arrow-link.view';

export default ArrowLink;
